import { State } from 'src/types'
import { basketForPitcherWeb } from 'src/features/brands/dxm/canvas/rightThrow/glove/back/web/basketWeb'
import { crossDoubleWeb, crossDoubleWebWithEdge } from 'src/features/brands/dxm/canvas/rightThrow/glove/back/web/crossDoubleWeb'
import { crossWeb } from 'src/features/brands/dxm/canvas/rightThrow/glove/back/web/crossWeb'
import { crossWebWithLaceWithEdge } from 'src/features/brands/dxm/canvas/rightThrow/glove/back/web/crossWebWithLace'
import { crossWithCrossLaceWeb } from 'src/features/brands/dxm/canvas/rightThrow/glove/back/web/crossWithCrossLaceWeb'
import { flatWeb } from 'src/features/brands/dxm/canvas/rightThrow/glove/back/web/flatWeb'
import { hWebWithEdge } from 'src/features/brands/dxm/canvas/rightThrow/glove/back/web/hWebWithEdge'
import { netWeb } from 'src/features/brands/dxm/canvas/rightThrow/glove/back/web/netWeb'
import { netWebDoubleWithEdge } from 'src/features/brands/dxm/canvas/rightThrow/glove/back/web/netWebDoubleWithEdge'
import { onePeaceWeb } from 'src/features/brands/dxm/canvas/rightThrow/glove/back/web/onePeaceWeb'
import { twoPeaceWeb } from 'src/features/brands/dxm/canvas/rightThrow/glove/back/web/twoPeaceWeb'
import { wo5Web } from './wo5Web'
import { wi8Web } from './wi8Web'
import { wi7Web } from './wi7Web'
import { wi9Web } from './wi9Web'
import { wi10Web } from './wi10Web'
import { wp4Web } from './wp4Web'
import { wp5Web } from './wp5Web'
import { reinforcementCrossLace } from '../lace/crossLace'
import { webDrawUtil } from 'src/features/brands/util/canvas'

export const webOfGloveBackDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const { webMatcher, webColor, laceColor, stitchColor, edgeColor } = webDrawUtil(state)
  if (state.baseModel.productNumber !== 'U300') reinforcementCrossLace(ctx, laceColor, 0, 0, 1, 1)
  if (webMatcher(['wp1'])) flatWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wp2'])) basketForPitcherWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wp3'])) twoPeaceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wp4'])) wp4Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wp5'])) wp5Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wi1'])) hWebWithEdge(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['wi2'])) crossWithCrossLaceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wi3'])) crossWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wi4'])) crossWebWithLaceWithEdge(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['wi6'])) onePeaceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wi5', 'wo1'])) netWeb(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['wi7'])) wi7Web(ctx, laceColor, stitchColor, edgeColor, webColor, webColor)
  if (webMatcher(['wi8'])) wi8Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wi9'])) wi9Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wi10'])) wi10Web(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['wo2'])) netWebDoubleWithEdge(ctx, webColor, laceColor, stitchColor, edgeColor)
  if (webMatcher(['wo3'])) crossDoubleWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['wo4'])) crossDoubleWebWithEdge(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['wo5'])) wo5Web(ctx, webColor, laceColor, stitchColor)
}
